import React, { useState, useEffect } from 'react';
import { Checkbox, FormControlLabel } from '@material-ui/core';

interface MatUiCheckboxProps {
  name?: string;
  label?: any;
  defaultValue?: any;
  size?: any; // mat-ui props
  disabled?: boolean;
  handleChange?: Function;
  value?: boolean;
  withoutMarginRight?: boolean;
}
const MatUiCheckbox: React.FC<MatUiCheckboxProps> = ({
  name,
  label,
  defaultValue = false,
  size,
  disabled,
  handleChange: handleChangeFromProps,
  value: valueFromProps,
  withoutMarginRight = false,
}) => {
  const [value, setValue] = useState(valueFromProps ?? defaultValue);
  const handleChange = (event: any) => {
    // event.preventDefault();
    event.stopPropagation();
    setValue(event.target.checked);
    if (handleChangeFromProps) {
      handleChangeFromProps(event.target.checked);
    }
  };
  useEffect(() => {
    setValue(valueFromProps ?? defaultValue);
  }, [valueFromProps, defaultValue]);
  return (
    <FormControlLabel
      control={
        <Checkbox
          checked={value}
          // onChange={handleChange}
          onClick={(e) => handleChange(e)}
          name={name}
          color="primary"
          size={size}
          style={{
            padding: 0,
            marginLeft: 0,
            marginRight: withoutMarginRight ? '0' : '9px',
          }}
        />
      }
      label={label}
      disabled={disabled}
      style={{
        marginLeft: 0,
        marginRight: 0,
      }}
    />
  );
};

export default MatUiCheckbox;
